import router from "./router";
import _nav from "./_nav";

export default {
  checkAccess: path => {
    let accesses = JSON.parse(localStorage.getItem("accesses"));
    let postId = localStorage.getItem("postId");
    if (postId === null || postId === undefined) {
      router.push({name: "ورود"});
    }
    if (!accesses || !accesses.map) {
      return;
    }
    let urls = accesses.map(a => {
      if (a.page && a.page.url) {
        return a.page.url.replace(/\//g, "");
      }
    });
    path = path.replace(/orders-list/g, "");
    path = path.replace(/\//g, "");
    path = path.replace("user-accesses", "access");
    path = path.replace("order-detail", "order");
    path = path.replace("purchase-order-detail", "purchase-order");
    path = path === "voucher" ? path.replace("voucher", "documents") : path;
    path = path === "accounting-documents" ? path.replace("accounting-documents", "accounting-documents-list") : path;
    path = path === "kardexCosts" ? "kardex" : path;
    path = path === "kardexReceive" ? "kardex" : path;
    path = path === "productsList" ? "products" : path;
    path = path === "productsListIRR" ? "products" : path;
    path = path === "productsListWithOutStock" ? "products" : path;
    path = path === "productsListWithOutStockIRR" ? "products" : path;

    // path = path.replace("/customerWorks", "Works");
    // path = path.replace("customerWorks", "Works");
    //
    // path = path.replace("/createWork", "Works");
    // path = path.replace("works", "patterns");

    // console.log("aaa");
    // console.log(path);
    // urls.page.url.add("customerWorks");
    urls.push("customerWorks");
    urls.push("checkBook");
    urls.push("manage-orders");
    urls.push("manage-buy-orders");
    urls.push("allcompanyproducts");
    urls.push("timesheet");
    urls.push("shifting");
    urls.push("shifting");
    urls.push("planning-orders");
    urls.push("planning-manual");
    urls.push("raw-planning");
    urls.push("inventory-planning");
    urls.push("workreport-total-program");
    urls.push("workreport-program");
    urls.push("randeman");
    urls.push("workreport-workshop");
    urls.push("workreport-problem");
    urls.push("printVoucher");
    urls.push("printOrder");
    urls.push("companySetting");
    // console.log(urls);
    if (!urls.includes(path) && postId !== "3006") {
      // TODO: uncomment
      router.push({name: "عدم دسترسی"});
    } else {
      let access = accesses
        .map(a => {
          if (a.page && a.page.url && a.page.url.replace(/\//g, "") === path) {
            return {add: a.add, read: a.read, edit: a.edit, delete: a.delete};
          }
        })
        .filter(a => {
          return a;
        })[0];

      if (postId === "3006") {
        access = {add: true, read: true, edit: true, delete: true};
      }
      return access;
    }
  },
  setNavItems: type => {
    let accesses = JSON.parse(localStorage.getItem("accesses"));
    if (!accesses || !accesses.map || !_nav) {
      return;
    }
    _nav.items = [];
    let postId = localStorage.getItem("postId");

    let names = accesses.map(a => {
      // console.log(a.page.persianName)
      return a.page.persianName;
    });

    // let panelsAccess = [];
    // if (
    //   names.includes("واحدها") ||
    //   names.includes("شرکت ها") ||
    //   names.includes("شرکت های خارجی") ||
    //   names.includes("محصولات") ||
    //   names.includes("نوع حواله")
    // ) {
    //   panelsAccess.push("base");
    // }

    if (type === "base" && localStorage.getItem('companyId') !== null) {
      /* let unit = {
         name: "واحدها",
         url: "/units",
         icon: "icon-ruler"
       };
       if (postId === "3006" || names.includes("واحدها")) {
         _nav.items.push(unit);
       }*/

      let company = {
        name: "کارگاه/دستگاه",
        url: "/company",
        icon: "icon-bd-building"
      };
      if (names.includes("شرکت ها")) {
        _nav.items.push(company);
      }
      let outsource = {
        name: "شرکت های خارجی",
        url: "/outsource",
        icon: "icon-bd-domain"
      };
      if (names.includes("شرکت های خارجی")) {
        _nav.items.push(outsource);
      }
      // let product = {
      //     name: "محصولات",
      //     url: "/products",
      //     icon: "icon-dropbox"
      //   };
      //   if (postId === "3006" || names.includes("محصولات")) {
      //     _nav.items.push(product);
      //   }
      let storeOrderStatus = {
        name: "فروشگاه",
        url: "/store-order-status",
        icon: "icon-cart-plus",
      };
      let workProblems = {
        name: "وقفه های کار",
        url: "/workProblems",
        icon: "icon-bd-close"
      };
      if (postId === "1" || names.includes("وقفه های کار")) {
        _nav.items.push(workProblems);
      }

      let damageType = {
        name: "علل ضایعات",
        url: "/damageType",
        icon: "icon-bd-close"
      };
      if (postId === "1" || names.includes("علل ضایعات")) {
        _nav.items.push(damageType);
      }
      let companySetting = {
        name: "تنظیمات",
        url: "/companySetting",
        icon: "icon-cart-plus",
      };
      if (names.includes("فروشگاه")) {
        _nav.items.push(storeOrderStatus)
        _nav.items.push(companySetting)
      }
      let baseInfo = {
        name: "اطلاعات پایه انبار",
        url: "/access",
        icon: "icon-bd-document",
        children: [
          {
            name: "کالاها",
            url: "/products",
            icon: "icon-dropbox"
          },
          {
            name: "واحدهای کالاها",
            url: "/units",
            icon: "icon-ruler"
          },
          {
            name: "نوع سند",
            url: "/voucher-type",
            icon: "icon-bd-document"
          },
          // {
          //   name: "معرفی انبار",
          //   url: "",
          //   icon: ""
          // },
          // {
          //   name: "معرفی انباردار",
          //   url: "",
          //   icon: ""
          // },
          // {
          //   name: "کاربران",
          //   url: "",
          //   icon: ""
          // },
        ]
      };
      if (postId === "1" || names.includes("اطلاعات پرسنل")) {
        _nav.items.push(baseInfo);
      }

    }

    if (type === "accountant") {

      ////////////////////////////////////////////////////////////////////
      let createDocument = {
        name: "مشاهده و ایجاد سند",
        url: "/access",
        icon: "icon-bd-edit",
        children: [
          {
            name: "ایجاد سند",
            url: "/accounting/",
            icon: ""
          },
          {
            name: "مشاهده و اصلاح سند",
            url: "/accounting-documents-list",
            icon: ""
          },

        ]
      };
      if (postId === "1" || names.includes("مشاهده و ایجاد سند")) {
        _nav.items.push(createDocument);
      }

      let Reports = {
        name: "گزارشات",
        url: "/access",
        icon: "icon-dropbox",
        children: [
          {
            name: "دفتر روز نامه",
            url: "/accounting/journal",
            icon: ""
          },
          {
            name: "دفاتر حساب",
            url: "/",
            icon: ""
          },
          {
            name: "تراز آزمایشی",
            url: "/",
            icon: ""
          },
          {
            name: "جستجو در سند",
            url: "/",
            icon: ""
          },
          {
            name: "گزارش گروه حساب ها",
            url: "/",
            icon: ""
          },
          {
            name: "سرفصل حساب ها",
            url: "/",
            icon: ""
          },
        ]
      };
      if (postId === "1" || names.includes("گزارشات")) {
        _nav.items.push(Reports);
      }

      let baseAccountingInfo = {
        name: "اطلاعات پایه حسابداری",
        icon: "icon-bd-document",
        url: '/accounting-documents-list',
        children: [
          {
            name: "سرفصل حسابها",
            url: "/accounts-titles",
            icon: ""
          },
          {
            name: "اشخاص",
            url: "/accounting/users",
            icon: ""
          },
          {
            name: "گروه های اشخاص",
            url: "/accounting/groupUsers",
            icon: ""
          },
          {
            name: "مراکز هزینه",
            url: "/accounting/CostCenters",
            icon: ""
          },
          {
            name: "حساب های دسته بندی",
            url: "/accounting/CategoryAccounts",
            icon: ""
          },
          {
            name: "عنوان فعالیت",
            url: "/accounting/ActivityType",
            icon: ""
          },
          {
            name: "گروه حساب ها",
            url: "/accounting/accountsGroup",
            icon: ""
          },
        ]
      };
      if (postId === "1" || names.includes("اطلاعات پایه orderDetailDescription")) {
        _nav.items.push(baseAccountingInfo);
      }
      let baseTreasuryInfo = {
        name: "اطلاعات پایه خزانه داری",
        url: "/access",
        icon: "icon-bd-document",
        children: [
          {
            name: "بانک ها",
            url: "/banks",
            icon: ""
          },
          {
            name: "حساب های بانکی",
            url: "/bank-accounts",
            icon: ""
          },
          {
            name: "دسته چک های بانکی",
            url: "/Accounting/CheckBook",
            icon: ""
          },
          {
            name: "صندوق",
            url: "/Accounting/cashier",
            icon: ""
          },
          {
            name: "تنخواه گردان",
            url: "/Accounting/PettyCash",
            icon: ""
          }
        ]
      };
      if (postId === "1" || names.includes("اطلاعات پایه خزانه داری")) {
        _nav.items.push(baseTreasuryInfo);
      }


      let facility = {
        name: "امکانات",
        url: "/access",
        icon: "icon-bd-document",
        children: [
          {
            name: "بستن حساب ها",
            url: "/",
            icon: ""
          },
          {
            name: "تغییر سال مالی",
            url: "/",
            icon: ""
          },

        ]
      };
      if (postId === "1" || names.includes("امکانات")) {
        _nav.items.push(facility);
      }


      ///////////////////////////////////////////////////////////
    }

    if (type === "inventory") {
      let document = {
        name: "اسناد انبار",
        url: "/documents",
        icon: "icon-bd-document-box-multiple"
      };
      let document2 =
        {
          name: "کالاها",
          url: "/products",
          icon: "icon-dropbox"
        };


      if (names.includes("اسناد انبار")) {
        _nav.items.push(document);
        _nav.items.push(document2);
      }

      // TODO: منوی سفارشات که حذف شده است
      // TODO: Orders meenu
      // let order = {
      //   name: "سفارشات مشتری",
      //   url: "/order",
      //   icon: "icon-cart",
      //   children: [
      //     {
      //       name: "لیست سفارشات",
      //       url: "/order",
      //       icon: "icon-file-document-box-multiple"
      //     },
      //     {
      //       name: "برنامه ریزی سفارشات",
      //       url: "/planning-orders",
      //       icon: "icon-content-duplicate"
      //       // name: "وضعیت سفارشات",
      //       // url: "/manage-orders",
      //       // icon: "icon-checkbox-marked-circle-outline"
      //     }
      //   ]
      //
      // };
      // if (names.includes("سفارش فروش")) {
      //   _nav.items.push(order);
      // }
      // let buyorder = {
      //   name: "سفارشات خرید-تامین",
      //   url: "/purchase-order",
      //   icon: "icon-cart-plus",
      //   children: [
      //     {
      //       name: "لیست خرید-تامین",
      //       url: "/purchase-order",
      //       icon: "icon-file-document-box-multiple"
      //     },
      //     {
      //       name: "وضعیت خرید-تامین",
      //       url: "/manage-buy-orders",
      //       icon: "icon-checkbox-marked-circle-outline"
      //     }
      //   ]
      // };
      // if (names.includes("سفارش خرید")) {
      //   _nav.items.push(buyorder);
      // }

      // TODO: uncomment blow section if you need it
      // ............................

      /*let purchaseOrder = {
        name: "سفارش خرید",
        url: "/purchase-order",
        icon: "icon-cart-plus"
      };
      if (postId === "3006" || names.includes("سفارش خرید")) {
        _nav.items.push(purchaseOrder);
      }

      // ............................
      let kardex = {
        name: "کارتکس کالا",
        url: "/kardex",
        icon: "icon-dropbox"
      };
      if (postId === "3006" || names.includes("کارتکس کالا")) {
        _nav.items.push(kardex);
      }*/

      // let WarehouseOperations = {
      //   name: "عملیات مقداری انبار",
      //   url: "/",
      //   icon: "icon-bd-document",
      //   children: [
      //     {
      //       name: "درخواست کالا از نبار",
      //       url: "",
      //       icon: ""
      //     },
      //     {
      //       name: "درخواست خرید کالا",
      //       url: "",
      //       icon: ""
      //     },
      //     {
      //       name: "سفارش خرید کالا",
      //       url: "",
      //       icon: ""
      //     },
      //     {
      //       name: "تصویب درخواست کالا",
      //       url: "",
      //       icon: ""
      //     },
      //     {
      //       name: "رسید کالا",
      //       url: "",
      //       icon: ""
      //     },
      //     {
      //       name: "حواله کالا",
      //       url: "",
      //       icon: ""
      //     },
      //     {
      //       name: "مصرف مستقیم کالا",
      //       url: "",
      //       icon: "",
      //     },
      //     {
      //       name: "انتقال کالا بین انبارها",
      //       url: "",
      //       icon: ""
      //     },
      //     {
      //       name: "اصلاح موجودی اولیه انبار",
      //       url: "",
      //       icon: "",
      //     },
      //     {
      //       name: "برگشت از رسید کالا",
      //       url: "",
      //       icon: "",
      //     },
      //     {
      //       name: "برگشت از حواله کالا",
      //       url: "",
      //       icon: ""
      //     },
      //     {
      //       name: "شمارش اول انبارگردانی",
      //       url: "",
      //       icon: ""
      //     },
      //     {
      //       name: "شمارش دوم انبارگردانی",
      //       url: "",
      //       icon: ""
      //     },
      //     {
      //       name: "شمارش سوم انبارگردانی",
      //       url: "",
      //       icon: ""
      //     }
      //   ]
      // };
      // if (postId === "1" || names.includes("عملیات مقداری انبار")) {
      //   _nav.items.push(WarehouseOperations)
      // }

      // let warehouseRialOperations = {
      //   name: "عملیات ریالی انبار",
      //   url: "/",
      //   icon: "icon-bd-document",
      //   children: [
      //     {
      //       name: "رسید کالا",
      //       url: "",
      //       icon: ""
      //     },
      //     {
      //       name: "حواله کالا",
      //       url: "",
      //       icon: ""
      //     },
      //     {
      //       name: "مصرف مستقیم کالا",
      //       url: "",
      //       icon: ""
      //     },
      //     {
      //       name: "انتقال کالا بین انبارها",
      //       url: "",
      //       icon: ""
      //     },
      //     {
      //       name: "اصلاح موجودی اولیه انبار",
      //       url: "",
      //       icon: ""
      //     },
      //     {
      //       name: "برگشت از رسید کالا",
      //       url: "",
      //       icon: ""
      //     },
      //     {
      //       name: "برگشت از حواله کالا",
      //       url: "",
      //       icon: ""
      //     }
      //   ]
      // };
      // if (postId === "1" || names.includes("عملیات ریالی انبار")) {
      //   _nav.items.push(warehouseRialOperations)
      // }

      let warehouseReports = {
        name: 'گزارشات مقداری انبار',
        url: "/",
        icon: "icon-bd-document",
        children: [
          {
            name: "کاردکس کالاها",
            url: "/kardex",
            icon: "icon-dropbox"
          },
          {
            name: "موجودی کالاها در کل شرکت",
            url: "/allcompanyproducts",
            icon: "icon-dropbox"
          },
          {
            name: "گردش درخواست کننده",
            url: "kardexReceive",
            icon: "icon-bd-document"
          },
          {
            name: "گردش  تامین کننده",
            url: "kardexCosts",
            icon: "icon-bd-document"
          },
          // {
          //   name: "لیست موجودی کالاها",
          //   url: "productsList",
          //   icon: "icon-dropbox"
          // },
          // {
          //   name: "لیست کالا",
          //   url: "productsListWithOutStock",
          //   icon: "icon-dropbox"
          // },

          // {
          //   name: "گردش  تامین کننده",
          //   url: "",
          //   icon: ""
          // },
          // {
          //   name: "گردش  کارگاه/قسمت",
          //   url: "",
          //   icon: ""
          // },
          // {
          //   name: "بیشترین تعداد گردش",
          //   url: "",
          //   icon: ""
          // },
          // {
          //   name: "کالاهای فاقد گردش",
          //   url: "",
          //   icon: ""
          // },
          // {
          //   name: "کالاهای حداقل موجودی",
          //   url: "",
          //   icon: ""
          // },
          // {
          //   name: "درخواست تحویل نشده",
          //   url: "",
          //   icon: ""
          // },
          // {
          //   name: "درخواست مصوب نشده",
          //   url: "",
          //   icon: ""
          // },
          // {
          //   name: "مغایرت شمارش اول",
          //   url: "",
          //   icon: ""
          // },
          // {
          //   name: "مغایرت شمارش دوم",
          //   url: "",
          //   icon: ""
          // },
          // {
          //   name: "مغایرت شمارش سوم",
          //   url: "",
          //   icon: ""
          // }
        ]
      };
      if (postId === "1" || names.includes("گزارشات مقداری انبار")) {
        _nav.items.push(warehouseReports);
      }


      // ----------------- extended sidebar for stock ------------------


      // let warehouseRialReports = {
      //   name: "گزارشات ریالی انبار",
      //   url: "/users",
      //   icon: "icon-bd-document",
      //   children: [
      //     {
      //       name: "کاردکس کالاها",
      //       url: "/kardexCosts",
      //       icon: "icon-dropbox"
      //     },
      //     {
      //       name: "لیست موجودی کالاها",
      //       url: "productsListIRR",
      //       icon: "icon-dropbox"
      //     },
      //     {
      //       name: "لیست کالا",
      //       url: "productsListWithOutStockIRR",
      //       icon: "icon-dropbox"
      //     },
      //     // {
      //     //   name: "گردش درخواست کننده",
      //     //   url: "",
      //     //   icon: ""
      //     // },
      //     // {
      //     //   name: "گردش تامین کننده",
      //     //   url: "",
      //     //   icon: ""
      //     // },
      //     // {
      //     //   name: "گردش کارگاه/قسمت",
      //     //   url: "",
      //     //   icon: ""
      //     // },
      //     // {
      //     //   name: "بیشترین تعداد گردش",
      //     //   url: "",
      //     //   icon: ""
      //     // },
      //     // {
      //     //   name: "کالاهای فاقد گردش",
      //     //   url: "",
      //     //   icon: ""
      //     // },
      //     // {
      //     //   name: "کالاهای حداقل موجودی",
      //     //   url: "",
      //     //   icon: ""
      //     // },
      //     // {
      //     //   name: "مغایرت شمارش اول",
      //     //   url: "",
      //     //   icon: ""
      //     // },
      //     // {
      //     //   name: "مغایرت شمارش دوم",
      //     //   url: "",
      //     //   icon: ""
      //     // },
      //     // {
      //     //   name: "مغایرت شمارش سوم",
      //     //   url: "",
      //     //   icon: ""
      //     // }
      //   ]
      // };
      // if (postId === "1" || names.includes("گزارشات ریالی انبار")) {
      //   _nav.items.push(warehouseRialReports);
      // }

      //----------------------------------------------------------------
    }

    if (type === "useradmin") {
      let user = {
        name: "کاربر ها",
        url: "/users",
        icon: "icon-bd-user"
      };
      if (names.includes("کاربر ها")) {
        _nav.items.push(user);
      }
      let access = {
        name: "سمت ها",
        url: "/access",
        icon: "icon-shield-key-outline"
      };
      if (names.includes("سمت ها")) {
        _nav.items.push(access);
      }
      let persons = {
        name: "اشخاص",
        url: "/persons",
        icon: "icon-bd-user"
      };
      if (names.includes("کاربر ها")) {
        _nav.items.push(persons);
      }

    }

    if (type === "order") {
      let orderList = {
        name: "سفارشات مشتری",
        url: "/order",
        icon: "icon-file-document-box-multiple"
      };
      if (names.includes("سفارش فروش")) {
        _nav.items.push(orderList);
      }
      let orderManage = {
        name: "برنامه ریزی سفارشات",
        url: "/planning-orders",
        icon: "icon-checkbox-marked-circle-outline"
      };
      if (names.includes("سفارش فروش")) {
        _nav.items.push(orderManage);
      }
      let buyorder = {
        name: "سفارشات خرید-تامین",
        url: "/purchase-order",
        icon: "icon-cart-plus",
        children: [
          {
            name: "لیست خرید-تامین",
            url: "/purchase-order",
            icon: "icon-file-document-box-multiple"
          },
          {
            name: "وضعیت خرید-تامین",
            url: "/manage-buy-orders",
            icon: "icon-checkbox-marked-circle-outline"
          }
        ]
      };
      if (names.includes("سفارش خرید")) {
        _nav.items.push(buyorder);
      }

    }

    //sidebar for task-flow

    if (type === "works") {

      if (names.includes("الگوها")) {
        _nav.items.push({
          name: "الگوهای تولید",
          url: "/product-patterns",
          icon: "icon-bd-document"
        });
      }

      let works = {
        name: "کارها",
        url: "/customerWorks",
        icon: "icon-file-document"
      };
      if (postId === "1" || names.includes("کارها")) {
        _nav.items.push(works)
      }
      let worksHome = {
        name: "کارگاه",
        url: "/works-home",
        icon: "icon-bd-building"
      };
      if (postId === "1" || names.includes("کارگاه")) {
        _nav.items.push(worksHome)
      }

      let workReport =
        {
          name: "گزارش کار",
          url: "/workreport-total-program",
          icon: "icon-file-document-box-multiple",
          children: [
            {
              name: "گزارش برنامه و کارکرد",
              url: "/workreport-total-program",
              icon: "icon-bd-document"
            },
            {
              name: "گزارش راندمان کارگاه ها",
              url: "/randeman",
              icon: "icon-bd-building"
            },

            {
              name: "جزیات گزارش برنامه",
              url: "/workreport-program",
              icon: "icon-bd-document"
            },
            {
              name: "گزارش کار سفارشات",
              url: "/workreport-workshop",
              icon: "icon-bd-document"
            },
            {
              name: "توقفهای تولید",
              url: "/workreport-problem",
              icon: "icon-bd-document"
            },
            {
              name: "ضایعات تولید",
              url: "/workreport-damage",
              icon: "icon-bd-document"
            },


          ]
        };
      if (postId === '1' || names.includes("گزارش کار")) {
        _nav.items.push(workReport)
      }

    }

    if (type === "planning") {

      // let planningOrders =
      //   {
      //     name: "برنامه ریزی",
      //     url: "/timeSheet",
      //     icon: "icon-file-document-box-multiple",
      //     children: [
      //       {
      //         name: "برنامه ریزی سفارشات",
      //         url: "/planning-orders",
      //         icon: "icon-content-duplicate"
      //       },
      //       {
      //         name: "برنامه ریزی دستوری",
      //         url: "/planning-manual",
      //         icon: "icon-bd-book-plus"
      //       },
      //       {
      //         name: "گزارش کار سفارشات",
      //         url: "/workreport-workshop",
      //         icon: "icon-bd-document"
      //       },
      //     ]
      //   };
      // if (postId === '1' || names.includes("وقفه های کار")) {
      //   _nav.items.push(planningOrders)
      // }
      if (names.includes("الگوها")) {
        _nav.items.push({
          name: "برنامه ریزی سفارشات",
          url: "/planning-orders",
          icon: "icon-content-duplicate"
        });
      }
      if (names.includes("الگوها")) {
        _nav.items.push({
          name: "برنامه ریزی دستوری",
          url: "/planning-manual",
          icon: "icon-bd-book-plus"
        });
      }
      if (names.includes("الگوها")) {
        _nav.items.push({
          name: "گزارش کار سفارشات",
          url: "/workreport-workshop",
          icon: "icon-bd-document"
        });
      }
      let timeSheet = {
        name: "تقویم کاری",
        url: "/timeSheet",
        icon: "icon-calendar-blank-outline",
        children: [
          {
            name: "روزهای کاری",
            url: "/timeSheet",
            icon: "icon-calendar-blank-outline"
          },
          {
            name: "تعریف شیفت",
            url: "/shifting",
            icon: "icon-calendar-edit"
          },
          {
            name: "ظرفیت زمانی کل شرکت",
            url: "/totalcompanyplanning",
            icon: "icon-bd-domain"
          },
          {
            name: "ظرفیت زمانی کارگاه",
            url: "/companyplanning",
            icon: "icon-bd-building"
          },

        ]
      };
      if (postId === "1" || names.includes("اطلاعات پرسنل")) {
        _nav.items.push(timeSheet)
      }

      let baseInfo = {
        name: "برنامه ریزی مواد",
        url: "/manage-orders",
        icon: "icon-bulletin-board",
        children: [
          {
            name: "موجودی کالاها در کل شرکت",
            url: "/allcompanyproducts",
            icon: "icon-dropbox"
          },
          {
            name: "برنامه ریزی مواد اولیه",
            url: "/raw-planning",
            icon: "icon-bd-document"
          },
          {
            name: "برآورد موجودی",
            url: "/inventory-planning",
            icon: "icon-file-document-box-multiple"
          },

        ]
      };
      if (postId === "1" || names.includes("اطلاعات پرسنل")) {
        _nav.items.push(baseInfo);
      }


      const outSourceId = localStorage.getItem("outSourceId")

      if (outSourceId && outSourceId !== "null") {
        let customerOrder = {
          name: "پیگیری سفارشات",
          url: "/customerOrders",
          icon: "icon-file-document"
        };
        if (postId === "1" || names.includes("سفارشات مشتری")) {
          _nav.items.push(customerOrder)
        }
      }
    }

    if (type === "pm") {


      if (names.includes("الگوها")) {
        _nav.items.push({
          name: "دستگاه ها",
          url: "/devices",
          icon: "icon-domain"
        });
      }

      if (names.includes("الگوها")) {
        _nav.items.push({
          name: "چک لیست ها",
          url: "/check-lists",
          icon: "icon-bd-document-box-multiple"
        });
      }
      if (names.includes("الگوها")) {
        _nav.items.push({
          name: "بازدیدها/سرویسها",
          url: "/check-services",
          icon: "icon-bd-accept"
        });
      }

      if (names.includes("الگوها")) {
        _nav.items.push({
          name: "گزارشات بازدید",
          url: "/report-services",
          icon: "icon-desktop-mac-dashboard"
        });
      }
      if (names.includes("الگوها")) {
        _nav.items.push({
          name: "گزارش نموداری بازدیدها",
          url: "/curve-report-services",
          icon: "icon-google-analytics"
        });
      }


    }

    //sidebar for Wage
    if (type === "biAccess") {
      let baseInformation = {
        name: "اطلاعات پایه",
        url: "/access",
        icon: "icon-bd-document-box-multiple",
        children: [
          {
            name: "سمتها",
            url: "/access",
            icon: ""
          },
          {
            name: "اقلام پرداختی",
            url: "",
            icon: ""
          },
          {
            name: "اقلام کسورات",
            url: "",
            icon: ""
          },
          {
            name: "اطلاعات بیمه",
            url: "",
            icon: ""
          },
          {
            name: "جدول مالیات",
            url: "",
            icon: ""
          },
          {
            name: "شیفت های کاری",
            url: "",
            icon: ""
          },
          {
            name: "ثابت های حقوق",
            url: "",
            icon: ""
          },
          {
            name: "انواع بدهی",
            url: "",
            icon: ""
          },
          {
            name: "انواع قرارداد ها",
            url: "",
            icon: ""
          },
          {
            name: "تقویم کاری",
            url: "/timesheet",
            icon: "icon-cart-plus"
          }
        ]
      };
      if (postId === "1" || names.includes("اطلاعات پایه")) {
        _nav.items.push(baseInformation);
      }
      let personalInformation = {
        name: "اطلاعات پرسنلی",
        url: "/access",
        icon: "icon-bd-document",
        children: [
          {
            name: "مشخصات پرسنل",
            url: "",
            icon: ""
          },
          {
            name: "احکام",
            url: "",
            icon: ""
          },
          {
            name: "حسابهای بانکی",
            url: "",
            icon: ""
          },
          {
            name: "اطلاعات بیمه و مالیات",
            url: "",
            icon: ""
          },
          {
            name: "سوابق کاری",
            url: "",
            icon: ""
          },
          {
            name: "سوابق تحصیلی",
            url: "",
            icon: ""
          },
          {
            name: "اطلاعات خانوادگی",
            url: "",
            icon: ""
          },
          {
            name: "پایان کار",
            url: "",
            icon: ""
          }
        ]
      };
      if (postId === "1" || names.includes("اطلاعات پرسنلی")) {
        _nav.items.push(personalInformation);

      }
      let debt = {
        name: "کارکرد/بدهی",
        url: "/users",
        icon: "icon-bd-user",
        children: [
          {
            name: "خلاصه کارکرد",
            url: "",
            icon: ""
          },
          {
            name: "خلاصه ماموریت",
            url: "",
            icon: ""

          },
          {
            name: "ثبت بدهی",
            url: "",
            icon: ""

          },
          {
            name: "ثبت اضافات و کسورات",
            url: "",
            icon: ""

          },
          {
            name: "کسر/عدم کسر بدهی",
            url: "",
            icon: ""

          },
        ]
      };
      if (postId === "1" || names.includes("کارکرد/بدهی")) {
        _nav.items.push(debt);
      }
      let reports = {
        name: "گزارشات",
        url: "",
        icon: "icon-dropbox",
        children: [
          {
            name: "کارکرد",
            url: "",
            icon: ""
          },
          {
            name: "لیست بیمه",
            url: "",
            icon: ""

          },
          {
            name: "ماموریت",
            url: "",
            icon: ""

          },
          {
            name: "فیش حقوقی",
            url: "",
            icon: ""

          },
          {
            name: "لیست پرداختی",
            url: "",
            icon: ""

          },
          {
            name: "لیست کسورات",
            url: "",
            icon: ""

          },
          {
            name: "لیست مالیات",
            url: "",
            icon: ""

          },
          {
            name: "لیست بانک",
            url: "",
            icon: ""

          },
          {
            name: "لیست وام",
            url: "",
            icon: ""

          },
          {
            name: "لیست اضافه کار",
            url: "",
            icon: ""

          },
          {
            name: "لیست بیمه ها",
            url: "",
            icon: ""

          },
          {
            name: "لیست احکام",
            url: "",
            icon: ""

          },
          {
            name: "لیست سوابق کار تحصیل خانواده",
            url: "",
            icon: ""

          }

        ]
      };
      if (postId === "1" || names.includes("گزارشات")) {
        _nav.items.push(reports);
      }
      let calculate = {
        name: "محاسبات",
        url: "documents",
        icon: "icon-dropbox",
        children: [
          {
            name: "محاسبه حقوق",
            url: "",
            icon: ""
          },
          {
            name: "ابطال حقوق",
            url: "",
            icon: ""

          },
          {
            name: "ارسال سند حسابداری",
            url: "",
            icon: ""

          },
          {
            name: "دیسکت حقوق",
            url: "",
            icon: ""

          },
          {
            name: "دیسکت بیمه",
            url: "",
            icon: ""

          },
          {
            name: "دیسکت مالیات",
            url: "",
            icon: ""
          }
        ]
      };
      if (postId === "1" || names.includes("محاسبات")) {
        _nav.items.push(calculate);
      }
    }

    //end sidebar for Wage


    return _nav.items;
  }
};

